// @flow

import NavContainer from './NavContainer';

export default NavContainer;
